module.exports = require("tls");


//////////////////
// WEBPACK FOOTER
// external "tls"
// module id = 248
// module chunks = 0 1 2 3